import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../state'
import * as overflowMenu from '../overflow-menu'

import * as change from './change'

/**
 * Displays a metric
 */
@ngCore.Component({
  imports: [
    change.Component,
    overflowMenu.Component,
    ds.layout.widget.Component,
    ds.notice.icon.Component,
    ds.tooltip.Directive,
    ngRouter.RouterLink,
  ],
  selector: 'atn-widget-metric',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ents.core.display.Metric} */
  // This component cannot utilize 'AtnMosaicWidgetStore' as it functions as a
  // child component within another widget component
  public readonly metricSg = ngCore.input.required<ents.core.display.Metric>({
    alias: 'metric',
  })

  /** @see {@link ents.core.mosaic.Action.Ref.WithIcon} */
  // This component cannot utilize 'AtnMosaicWidgetStore' as it functions as a
  // child component within another widget component
  public readonly overflowActionsSg = ngCore.input<
    readonly ents.core.mosaic.Action.Ref.WithIcon[],
    readonly ents.core.mosaic.Action.Ref.WithIcon[] | undefined
  >([], {
    alias: 'overflowActions',
    transform: input => input ?? [],
  })

  /** @see {@link state.mosaic.models.widget.Ref.Id} */
  public readonly refIdSg = ngCore.input<
    state.mosaic.models.widget.Ref.Id | undefined
  >(undefined, { alias: 'refId' })

  /** Indicates whether the metric is used for report card. */
  public readonly isReportCardSg = ngCore.input<boolean>(false, {
    alias: 'isReportCard',
  })

  /** @see {@link state.mosaic.endUser.currentRendering.Feature} */
  private readonly _currentRendering = ngCore.inject(
    state.mosaic.endUser.currentRendering.Feature,
  )

  /** @see {@link ents.core.display.Metric.value} */
  public readonly valueSg = ngCore.computed(
    (metric = this.metricSg()) => metric.value,
  )

  /** @see {@link ents.core.display.Metric.notice} */
  public readonly noticeSg = ngCore.computed(
    (metric = this.metricSg()) => metric.notice,
  )

  /** @see {@link ents.core.display.Metric.change} */
  public readonly metricChangeSg = ngCore.computed(
    (metric = this.metricSg()) => metric.change,
  )

  /** @see {@link ents.core.display.Metric.name} */
  public readonly nameSg = ngCore.computed(
    (metric = this.metricSg()) => metric.name,
  )
  /** @see {@link ents.core.display.Metric.description} */
  public readonly descriptionSg = ngCore.computed(
    (metric = this.metricSg()) => metric.description,
  )

  /** @see {@link event.core.display.Metric.event } */
  public readonly eventSg = ngCore.computed(
    (metric = this.metricSg()) => metric.event,
  )

  /**
   * Exposing {@link ents.core.common.Quality | quality} enum to HTML
   */
  public readonly QualityEnum = ents.core.common.Quality
}
